"use strict";
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require("path");

module.exports = {
  dev: {
    // Paths
    assetsSubDirectory: "static",
    assetsPublicPath: "/",
    proxyTable: {
      "/api": {
        // target: 'http://localhost:5001', // 本机
        //  target: 'http://192.168.14.33:5001', // 本机
        //  target: 'http://192.168.2.91:5001', // 测试
        //  target: 'http://192.168.10.132:5001', // 联调
        //  target: 'http://192.168.1/4.156:5001', //林
        // target: 'http://192.168.14.229:5001', //张
        // target: 'http://192.168.10.132:5001', //张
        // target: 'http://192.168.14.44:5001', //杜
        //target: 'http://192.168.10.63:8080', // 果
        //oa.nlxdt.com:5001
        target: 'http://oa.newlixon.com:5001',
        // target: "http://192.168.97.41:5001", // 联调
        changeOrigin: true,
        secure: false,
        pathRewrite: {
          "^/api": "",
        },
      },
      "/aws": {
        target: "ws://oa.newlixon.com:5001/ims",
        // target: 'ws://192.168.10.132:5002/ims',
        // target: 'ws://36.152.34.20.5001', // 联调
        ws: true,
        secure: false,
        logLevel: "debug",
        changeOrigin: true,
        pathRewrite: {
          "^/aws": "",
        },
      },
    },

    // Various Dev Server settings
    // host: '0.0.0.0', // can be overwritten by process.env.HOST
    host: "localhost", // can be overwritten by process.env.HOST
    // host: '192.168.5.66', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: true,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: "cheap-module-eval-source-map",

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true,
  },

  build: {
    prodEnv: require("./prod.env"),
    testEnv: require("./test.env"),
    // Template for index.html
    index: path.resolve(__dirname, "../dist/index.html"),

    // Paths
    assetsRoot: path.resolve(__dirname, "../dist"),
    assetsSubDirectory: "static",
    assetsPublicPath: "/",

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: "#source-map",

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ["js", "css"],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report,
  },
};



// WEBPACK FOOTER //
// ./config/index.js